export default __webpack_public_path__ + "static/media/100x100-Loader.fc8ca3af.gif";